module.exports = __webpack_public_path__ + "img/animated-background-blue.1024da59.svg";